export default __webpack_public_path__ + "static/media/metamask.67bf04bd.svg";